var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v("Document viewed on "+_vm._s(_vm._f("formatDateTime")(_vm.row.created)))]),_vm._v(" "),_c('br'),_c('router-link',{attrs:{"to":`/admin/documents/${_vm.row.data.documentId}`}},[_vm._v("View Document")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }